<template>
  <div class="echart-box-cla">
    <div class="chart_title_cla">
      <div class="title-bg-cla"></div>
      <div class="title-Text-cla">{{$t('dashboard.areaDeviceTop10')}}</div>
    </div>
    <div  id="map_bar_chart" class="echart-cla"></div>
  </div>
</template>

<script>
import { getOptionConfig } from './barChar.js'
import { devLocationTotal } from '@/services/dashboardApi.js'
var echarts = require('echarts')
export default {
  data() {
    return {
      barChart: null,
      category: [],
      barData: [],
      dataList: [],
      timeout: null,
      intervalMapBar: null
    }
  },
  mounted() {
    let _this = this
    this.getData()
    window.addEventListener('resize', this.resizeChart, true)
    this.intervalMapBar = setInterval(() => {
      _this.getData()
    }, 10000)
  },
  beforeDestroy() {
    this.barChart.clear()
    this.barChart.dispose()
    window.removeEventListener('resize', this.resizeChart, true)
    if (this.intervalMapBar) {
      clearInterval(this.intervalMapBar)
    }
  },
  methods: {
    resizeChart() {
      if (this.barChart) {
        this.debounce(this.barChart.resize, 200)
      }
    },
    debounce(func, wait) {
      let context = this
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.timeout = setTimeout(() => {
        func.apply(context, arguments)
      }, wait)
    },
    getOption() {
      let lang = {
        title: this.$t('dashboard.areaDeviceTop10')
      }
      let option = getOptionConfig(this.category, this.barData, lang)
      this.renderChart(option)
    },
    renderChart(option) {
      if (!this.barChart) {
        this.barChart = echarts.init(document.getElementById('map_bar_chart'))
      }
      this.barChart.setOption(option, true)
    },

    getData() {
      devLocationTotal().then((data) => {
        if (data.code === '00000000') {
          let result = data.payload.data
          this.category = result.key
          this.barData = result.value
          this.getOption()
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/dashboard/mapBarChar/mapBarChar.vue